import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { LL_V_L, ModuleFE_Dialog, ModuleFE_Thunderstorm, TS_Dialog, TS_Input, TS_PropRenderer } from '@nu-art/thunderstorm-frontend/index';
import { ICONS } from '@app/styles';
import { Week } from '@nu-art/ts-common';
import { ModuleFE_Account } from '@nu-art/user-account-frontend/index';
import './Dialog_GenerateToken.scss';
export class Dialog_GenerateToken extends TS_Dialog {
    static defaultProps = {
        dialogId: 'generate-token',
    };
    static show(accountId) {
        ModuleFE_Dialog.show({
            content: _jsx(Dialog_GenerateToken, { accountId: accountId, className: 'dialog' }),
            closeOverlayOnClick: () => false
        });
    }
    // ######################## Life Cycle ########################sc
    deriveStateFromProps(nextProps, state) {
        state.dialogIsBusy ??= false;
        state.ttl ??= 0;
        return state;
    }
    // ######################## Logic ########################
    closeDialog = () => {
        if (!this.state.dialogIsBusy)
            ModuleFE_Dialog.close();
    };
    canCreate = () => {
        return !!this.state.ttl;
    };
    execute = async () => {
        if (!this.canCreate())
            return;
        if (this.state.token)
            return ModuleFE_Thunderstorm.copyToClipboard(this.state.token);
        try {
            const { token } = await ModuleFE_Account._v1.createToken({
                accountId: this.props.accountId,
                ttl: this.state.ttl,
                label: 'why-from-dialog'
            }).executeSync();
            await ModuleFE_Thunderstorm.copyToClipboard(token);
            this.setState({ token: token });
        }
        catch (err) {
            this.logError(err);
            this.setState({ error: err });
        }
    };
    // ######################## Render ########################
    renderErrorGenerating = () => {
        return _jsxs(LL_V_L, { className: 'created-title', children: [_jsx(ICONS.x.component, {}), _jsx("div", { className: 'title', children: "Couldn't Generate Token, Please Try Again." })] });
    };
    renderHeader = () => {
        return _jsxs(_Fragment, { children: [_jsx("span", { className: "header__title", children: "Generated Token" }), _jsx("div", { className: 'header__buttons', children: _jsx(ICONS.x.component, { className: "exit_icon", onClick: this.closeDialog }) })] });
    };
    renderBody = () => {
        if (this.state.error)
            return this.renderErrorGenerating();
        if (this.state.token)
            return _jsxs(LL_V_L, { className: 'created-title', children: [_jsx(ICONS.v.component, {}), _jsx("div", { className: 'title', children: "Token Generated Successfully" })] });
        return _jsx(_Fragment, { children: _jsx(TS_PropRenderer.Vertical, { label: 'TTL (In years)', children: _jsx(TS_Input, { type: 'number', onKeyDown: (e) => {
                        if (e.key === '.' || e.key === ',' || (e.target.value.length === 0 && e.key === '0')) {
                            e.preventDefault();
                        }
                    }, onBlur: (val) => {
                        this.setState({ ttl: (Week * 52) * Number(val) });
                    } }) }) });
    };
    buttons = () => {
        return {
            center: [
                {
                    content: this.state.token ? 'Copy To Clipboard' : 'Generate Token',
                    onClick: this.execute,
                    className: 'desired-action-button',
                    associatedKeys: ['Enter'],
                }
            ]
        };
    };
}
